<template>
	<div class="tmpl-layout" :style="{ height: windowHeight }">
		<keep-alive :include="keepAliveIncludes">
			<router-view :key="$route.fullPath" />
		</keep-alive>
		<SmartLayoutC
			v-if="showFloating"
			ref="floating"
			compId="layout_floating"
			mode="basic"
			delay
			:operateList="floatingOptions"
		></SmartLayoutC>
	</div>
</template>

<script setup>
import { get100vh } from '@/utils/api';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useFloating } from '@rebuild/materials/shared/layout_floating/useFloating';
import { useKeepAliveInclude } from '@rebuild/hooks/cache/useKeepAliveInclude';

const windowHeight = get100vh();
const { showFloating, floatingOptions, floating } = useFloating();

const { keepAliveIncludes } = useKeepAliveInclude();
</script>

<style lang="less" scoped>
.tmpl-layout {
	background-color: #f6f7f8;
}
</style>
